import { faBarcodeRead } from '@fortawesome/pro-duotone-svg-icons';
import { faUtensils } from '@fortawesome/pro-duotone-svg-icons';
import { faLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router';
import { tss } from 'tss-react';

import { MenuPlannerItemsBulkResponse } from 'api/menuPlanner/GetMenuPlannerItemsBulk';
import * as State from 'components/desktop/ShoppingCart/Detail/State';
import ButtonGroup from 'components/desktop/ShoppingCart/Detail/misc/ButtonGroup';
import OverviewCard from 'components/desktop/ShoppingCart/Detail/misc/OverviewCard';
import Title from 'components/desktop/ShoppingCart/Detail/misc/Title';
import ProductsTab from 'components/desktop/ShoppingCart/Detail/tabs/ProductsTab';
import ProductsTabTemp from 'components/desktop/ShoppingCart/Detail/tabs/ProductsTabTemp';
import SourcesTab from 'components/desktop/ShoppingCart/Detail/tabs/SourcesTab';
import useState from 'components/desktop/ShoppingCart/Detail/useState';
import { ShoppingCartDetailHandlers } from 'components/desktop/ShoppingCart/Detail/useState';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import Tabs from 'components/desktop/_general/Tabs/Tabs';
import useTranslation from 'hooks/useTranslation';
import { ShoppingCart } from 'types/ShoppingCart/ShoppingCart';
import STATUS from 'types/ShoppingCart/Status';

interface IProps {
	cart: ShoppingCart.Type;
	editMode?: boolean;
	menuPlanOrders?: MenuPlannerItemsBulkResponse[];
	refreshMenuPlanOrders: () => void;
}

const ShoppingCartDetailContainer = ({
	cart,
	editMode,
	menuPlanOrders,
	refreshMenuPlanOrders,
}: IProps) => {
	const { state, handlers } = useState(editMode);
	const { classes } = useStyles();
	const { t } = useTranslation();
	const navigate = useNavigate();

	const defaultProps: RecipeErpViewComponentProps = {
		state: state,
		cart: cart,
		handlers: handlers,
	};

	return (
		<div>
			<button
				className="btn btn-outline-light btn-sm"
				style={{ color: 'black', marginBottom: '1rem' }}
				onClick={() => navigate('/shoppingCart/search')}
			>
				<FontAwesomeIcon icon={faLeft} style={{ marginRight: '0.5rem' }} />
				{t('_general:BACK')}
			</button>
			<div className={classes.header}>
				<Title {...defaultProps} />
				<RenderIf condition={cart.status !== STATUS.APPROVED}>
					<ButtonGroup {...defaultProps} />
				</RenderIf>
			</div>
			<div className={`${classes.container} row`}>
				<div className={`${classes.tabs} col-md-8`}>
					<Tabs
						localStorageKey={'shoppingCartDetail'}
						tabs={[
							{
								name: t('shoppingCart:SOURCES'),
								content: (
									<SourcesTab
										{...defaultProps}
										menuPlanOrders={menuPlanOrders ?? []}
										refreshMenuPlanOrders={refreshMenuPlanOrders}
									/>
								),
								icon: faUtensils,
							},
							{
								name: t('shoppingCart:PRODUCTS'),
								content: <ProductsTab {...defaultProps} />,
								icon: faBarcodeRead,
							},
						]}
					/>
					<ProductsTabTemp {...defaultProps} />
				</div>
				<div className={`${classes.overview} col-md-4`}>
					<OverviewCard {...defaultProps} />
				</div>
			</div>
		</div>
	);
};

export const useStyles = tss.create({
	container: {
		marginTop: '2rem',
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'top',
		gap: '20px',
		marginBottom: '20px',
	},
	tabs: {
		flexGrow: '1',
	},
	overview: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
	},
});

export default ShoppingCartDetailContainer;

export interface RecipeErpViewComponentProps {
	state: State.Type;
	cart: ShoppingCart.Type;
	handlers: ShoppingCartDetailHandlers;
}
